import type { FC } from 'react'

import { AccountBar } from './AccountBar'
import Banner from './Banner'

import './header.scss'

export const Header: FC = () => (
  <header>
    <div className="content">
      <Banner />
      <AccountBar />
    </div>
  </header>
)
